module.exports = __webpack_public_path__ + "img/10-real-name-level.b86d32ab.png";